import { toUrl } from '@execonline-inc/url';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../../../../LinkyLinky';
import { isTrustedFrameMessage } from '../../../../WindowMessageReactions/isTrustedFrameMessage';
import { windowMessageDecoder } from './Decoders';
import { WindowMessage } from './Types';
import VPFAlumniSurveyModalStore from '..';

interface Props {
  store: VPFAlumniSurveyModalStore;
  iFrameRef: React.RefObject<HTMLIFrameElement | null>;
}

@observer
class WindowMessageReactions extends React.Component<Props> {
  get surveyOrigin() {
    return findLink('survey', this.props.store.links)
      .andThen(({ href }) => toUrl(href))
      .map(({ origin }) => origin);
  }

  messageHandler = (e: MessageEvent) => {
    if (!isTrustedFrameMessage(e, this.surveyOrigin, this.props.iFrameRef.current?.contentWindow)) {
      return;
    }

    windowMessageDecoder.decodeJson(e.data).cata({
      Err: (err) => {
        return;
      },
      Ok: (windowMessage: WindowMessage) => {
        switch (windowMessage.kind) {
          case 'complete-and-close':
            this.props.store.closeAndComplete();
            break;
          default:
            break;
        }
      },
    });
  };

  componentDidMount() {
    window.addEventListener('message', this.messageHandler);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.messageHandler);
  }

  render() {
    return <span />;
  }
}

export default WindowMessageReactions;
